import styles from './HorizontalLine.module.css';

export function HorizontalLine() {
    return <div className={styles.line} />;
}
